import { useMemo } from 'react';

import { defaultColors, EPaletteModes, IColorVariants, ThemePack } from '@/types/theme-packs.types';

export const useGetColorOptionsFromColor = (
  color?: ThemePack | null,
  colorTheme = EPaletteModes.Light
): IColorVariants => {
  // intentionally separately pulling light and dark so they don't get added to topLevelColors
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { [colorTheme]: colorsByTheme, light, dark, ...topLevelColors } = color?.colors || defaultColors;

  return useMemo(() => {
    return colorsByTheme || topLevelColors;
  }, [colorsByTheme, topLevelColors]);
};
